import React, { Component } from 'react';
import { Card, CardHeader, CardBody, CardFooter, Row, Col, Table, Button, FormGroup, Label, Input, InputGroup, InputGroupAddon, InputGroupText, Tooltip, Modal, ModalBody, ModalFooter } from 'reactstrap';
import LaddaButton, { EXPAND_LEFT } from 'react-ladda';
import { toast } from 'react-toastify';
import withSizes from 'react-sizes'

import Config from '../../config';
import FastButtons from './FastButtons';

import ClientSearch from '../../components/Client/Search';
import ClientEditor from '../../components/Client/Editor';
import ProductSearch from '../../components/Product/Search';

import './ShoppingCart.css';
import './Payment.css';

class ShoppingCart extends Component {
 constructor(props) {
  super(props);

  this.addToCart = this.addToCart.bind(this);
  this.toogleSale = this.toogleSale.bind(this);

  this.checkTaxes = this.checkTaxes.bind(this);
  this.applyTaxes = this.applyTaxes.bind(this);
  this.skipTaxes = this.skipTaxes.bind(this);

  this.setItemTax = this.setItemTax.bind(this);
  this.setItemNotes = this.setItemNotes.bind(this);
  this.setItemPrice = this.setItemPrice.bind(this);
  this.addItemQuantity = this.addItemQuantity.bind(this);
  this.delItemQuantity = this.delItemQuantity.bind(this);
  this.setItemQuantity = this.setItemQuantity.bind(this);
  this.setItemDiscount = this.setItemDiscount.bind(this);
  this.setItemSurcharge = this.setItemSurcharge.bind(this);

  this.handleBlur = this.handleBlur.bind(this);
  this.handleFocus = this.handleFocus.bind(this);
  this.handleKeyPress = this.handleKeyPress.bind(this);
  this.handleDoubleClick = this.handleDoubleClick.bind(this);
  this.handleInputEL = this.handleInputEL.bind(this);

  this.handleModal = this.handleModal.bind(this);

  this.setClient = this.setClient.bind(this);
  this.unsetClient = this.unsetClient.bind(this);
  this.setComments = this.setComments.bind(this);

  this.toogleInvoice = this.toogleInvoice.bind(this);
  this.handlePayMethod = this.handlePayMethod.bind(this);
  this.handleSubmit = this.handleSubmit.bind(this);

  this.resetAll = this.resetAll.bind(this);

  this.state = {
   ID: false
  }
 }

 resetAll() {
  this.setState({
   ID: false,
   sale: Config.defaultSaleMode,
   cash: Config.defaultCashMode,
   client: null,
   invoice: false,
   comments: false,
   validated: false,
   laddaloading: false,
   tooltip: {
    discount: false,
    surcharge: false,
    tax: false
   },
   modals: {
    no_taxes: false,
    no_client: false,
    new_client: false,
    no_comment: false,
    do_reset: false
   },
   items: [],
   subtotal: 0,
   discounts: 0,
   surcharges: 0,
   taxes: 0,
   total: 0,
   given: 0,
   paid: 0
  }, () => {
   window.scrollTo(0, 0);
   this.inputElement.focus();
  });
 }


 roundNumber(value, exp) {
  if(exp >= 0) {
   exp = Math.pow(10, exp);
   return Math.ceil(value * exp) / exp;
  } else {
   exp = Math.pow(10, exp * -1);
   return Math.round(value * exp) / exp;
  }
 }

 calculatePrice(item, invoice) {
  var amount = 0;

  if(invoice && item.tax === 0) {
   var taxrate = 1.21;
   item.price = item.amount * taxrate;
   item.tax = 21;
  } else {
   var taxrate = ((item.tax + 100) / 100);
   item.amount = item.price / taxrate;
  }

  if(item.discount > 0) {
   amount -= (item.amount * (item.discount / 100));
  }

  if(item.surcharge > 0) {
   amount += (item.amount * (item.surcharge / 100));
  }

  if(amount !== 0) {
   amount = item.amount + amount;
   item.finalprice = amount * taxrate;
  } else {
   item.finalprice = item.price, 2;
  }

  item.finalprice = this.roundNumber(item.finalprice * item.quantity, -2);
  return item;
 }



 addToCart(item) {
  var items = this.state.items;
  if(items.find(i => i.ID === item.ID && i.notes === '') === undefined) {
   items.unshift(this.calculatePrice({
    ID: item.ID, name: item.name, notes: '',
    amount: item.amount ? parseFloat(item.amount) : 0,
    price: item.price ? parseFloat(item.price) : 0,
    tax: item.tax ? parseFloat(item.tax) : 0,
    surcharge: 0, discount: 0, quantity: 1
   }));
  } else {
   items.forEach(i => {
    if(i.ID === item.ID) {
     i.quantity++;
     i = this.calculatePrice(i);
    }
   })
  }

  if(parseFloat(item.tax) === 0 && this.state.invoice) {
   this.handleModal('no_taxes', true, {validated: false, items});
  } else {
   this.setState({validated: false, items});
  }
 }


 toogleSale() {
  this.setState({sale:!this.state.sale}, () => {
   this.inputElement.focus();
  });
 }

 checkTaxes() {
  try {
   this.state.items.forEach((item, key) => {
    if(item.tax === 0) throw BreakException;
   });
   return true;
  } catch(e) {
   return false;
  }
 }

 applyTaxes() {
  var newItems = this.state.items;
  newItems.forEach((item, key) => {
   newItems[key] = this.calculatePrice(item, true);
  });
  this.handleModal('no_taxes', false, {validated: false, items: newItems });
 }

 skipTaxes() {
  this.handleModal('no_taxes', false);
 }

 
 setComments(e) {
  this.setState({validated: false, comments: e.target.value});
 }

 setItemTax(key, e) {
  if(e.target.value !== '') {
   var newItems = this.state.items;
   newItems[key].tax = parseFloat(e.target.value);
   newItems[key] = this.calculatePrice(newItems[key]);
   this.setState({validated: false, items: newItems});
  }
 }

 setItemNotes(key, e) {
  var newItems = this.state.items;
  newItems[key].notes = e.target.value;
  this.setState({validated: false, items: newItems});
 }

 setItemPrice(key, e) {
  if(e.target.value !== '') {
   var newItems = this.state.items;
   newItems[key].price = parseFloat(e.target.value.replace(',', '.'));
   newItems[key] = this.calculatePrice(newItems[key]);
   this.setState({validated: false, items: newItems});
  }
 }

 addItemQuantity(key) {
  var newItems = this.state.items;
  newItems[key].quantity ++;
  newItems[key] = this.calculatePrice(newItems[key]);
  this.setState({validated: false, items: newItems});
 }

 delItemQuantity(key) {
  var newItems = this.state.items;
  newItems[key].quantity --;
  newItems[key] = this.calculatePrice(newItems[key]);
  if(newItems[key].quantity <= 0) newItems.splice(key, 1);
  this.setState({validated: false, items: newItems});
 }

 setItemQuantity(key, e) {
  if(e.target.value !== '') {
   var newItems = this.state.items;
   newItems[key].quantity = parseInt(e.target.value.split('+').reduce(function(a,b){ return+a+(+b); }), 10);
   newItems[key] = this.calculatePrice(newItems[key]);
   if(newItems[key].quantity <= 0) newItems.splice(key, 1);
   this.setState({validated: false, items: newItems});
  }
 }

 setItemDiscount(key, e) {
  if(e.target.value !== '') {
   var newItems = this.state.items;
   newItems[key].discount = parseFloat(e.target.value, 10);
   newItems[key] = this.calculatePrice(newItems[key]);
   this.setState({validated: false, items: newItems});
  }
 }

 setItemSurcharge(key, e) {
  if(e.target.value !== '') {
   var newItems = this.state.items;
   newItems[key].surcharge = parseFloat(e.target.value, 10);
   newItems[key] = this.calculatePrice(newItems[key]);
   this.setState({validated: false, items: newItems});
  }
 }



 handleBlur(e) {
  e.persist();
  e.target.value = '';
  
  if(e.target.name === 'tooltip') {
   var tooltip = this.state.tooltip;
   tooltip[e.target.id] = false;
   this.setState({ tooltip });
  }
 }

 handleFocus(e) {
  e.persist();
  var placeholders = ['...', '0.00', 'Observaciones...'];
  if(placeholders.indexOf(e.target.placeholder) < 0) e.target.value = e.target.placeholder;
  if(e.target.name === 'tooltip') {
   var tooltip = this.state.tooltip;
   tooltip[e.target.id] = true;
   this.setState({ tooltip });
  }
 }

 handleKeyPress(e) {
  if (e.key === 'Enter') {
   e.target.value = '';
   this.inputElement.focus();
  }
 }

 handleDoubleClick(e) {
  if(e.ctrlKey) {
   if(e.target.value === '') e.target.value = 0;
   var newItems = this.state.items;
   newItems.forEach((item, key) => {
    newItems[key][e.target.id] = parseFloat(e.target.value);
    newItems[key] = this.calculatePrice(newItems[key]);
   });
   this.setState({validated: false, items: newItems});
  }
 }

 handleInputEL(el) {
  this.inputElement = el;
 }

 handleModal(name, value, state) {
  var modals = this.state.modals;
  if(typeof name === 'string') {
   modals[name] = value;
  } else {
   name.map((e) => {
    modals[e] = value;
   });
  }
  
  if(typeof state !== 'undefined') {
   this.setState({...{modals}, ...state});
  } else {
   this.setState({modals});
  }
 }


 setGiven(e) {
  this.setState({validated: false, given: e.target.value === ''? 0: parseFloat(e.target.value.replace(',', '.'))});
 }

 setPaid(e) {
  this.setState({validated: false, paid: e.target.value === ''? 0: parseFloat(e.target.value.replace(',', '.'))});
 }

 getCash() {
  var toreturn = this.state.given - (this.state.total - this.state.paid);
  if(toreturn > 0) {
   return toreturn;
  } else {
   return 0;
  }
 }

 setClient(client) {
  var newState = {client, invoice: true};
  if(!this.checkTaxes()) {
   this.handleModal('no_taxes', true, newState)
  } else {
   this.setState(newState);
  }
 }

 unsetClient() {
  this.setState({client: null, invoice: false});
 }

 toogleInvoice() {
  if(!this.state.client) {
   this.handleModal('no_client', true);
  } else if(this.state.invoice) {
   this.setState({invoice: false});
  } else if(!this.checkTaxes()) {
   this.handleModal('no_taxes', true, {invoice: true})
  } else {
   this.setState({invoice: true});
  }
 }

 handlePayMethod() {
  this.setState({cash:!this.state.cash});
 }

 handleSubmit() {
  if(this.state.items.length > 0) {
   // Si se ha completado, guardamos
   if(this.state.validated) {
    this.handleSave();
    return true;
   }

   // Si el total es cero se requiere un comentario
   if((this.state.total - this.state.paid) === 0 && this.state.comments.toString().length < 10) {
    this.handleModal('no_comment', true);
    return false;
   }

   // Si es una factura, todos los articulos deben llevar IVA
   if(this.state.invoice && !this.checkTaxes()) {
    this.handleModal('no_taxes', true);
    return false;
   }

   if(!this.state.sale || !this.state.cash) {
    this.handleSave();
    return true;
   }

   
   if(this.state.cash && (this.state.given - (this.state.total - this.state.paid) > 0)) {
    // Si hay que dar cambio, primero validamos
    this.setState({validated: true});
    return false;
   } else if(this.state.cash && (this.state.given - (this.state.total - this.state.paid) === 0)) {
    // Si no hay cambio, guardamos
    this.handleSave();
    return true;
   }
  }
 }


 handleSave() {
  this.setState({laddaloading: true});
  var output = {
   ID: this.state.ID,
   paid: this.state.paid,
   total: this.state.total,
   invoice: this.state.invoice,
   comments: this.state.comments
  }

  if(this.state.invoice) output = {...output, ...{clientID: this.state.client.ID}}
  this.props.reqAPI(Config.apiURI+'/api/orders', 'POST', output).then((data) => {
   if(data.success) {
    toast.success('Operación completada con éxito');
    if(data.invoice && data.base64) {
     const downloadLink = document.createElement("a");
     downloadLink.href = `data:application/pdf;base64,${data.base64}`;;
     downloadLink.download = "Factura-"+data.invoice.replace('/','.')+".pdf";
     downloadLink.click();
    }
    this.resetAll();
   } else {
    toast.error('Se ha producido un error! Código de error: ' + this.state.ID);
    console.log(data);
   }
  }).catch((error) => {
   this.setState({laddaloading: false});
   console.log(error);
  })
 }

 componentWillMount() {
  this.resetAll();
 }

 componentDidUpdate() {
  this.props.reqAPI(Config.apiURI+'/api/orders', 'PUT', {
   ID: this.state.ID,
   type: this.state.sale,
   payment: this.state.cash,
   items: this.state.items,
  }).then((result) => {
   if(typeof result.ID !== 'undefined') this.setState(result);
  }).catch((error) => {
   console.log(error);
  })
 }
 

 componentDidMount(){
  if(this.inputElement) this.inputElement.focus();
  /* window.addEventListener("beforeunload", (ev) => {
   ev.preventDefault();
  }); */
 }

 render() {
  var cashBackAlert = '';
  var cashInputClassName = '';
  var givenInputClassName = '';
  var textareaClassName = '';

  var cancelButtonShow = true;
  var cancelButtonTitle = 'Borrar';
  var cancelButtonDisabled = true;
  var cancelButtonClassName = 'btn btn-sm btn-';

  var submitButtonTitle = 'Finalizar';
  var submitButtonDisabled = true;
  var submitButtonClassName = 'btn btn-sm btn-success btn-ladda';

  if(this.state.items.length > 0) {
   var cancelButtonDisabled = false;
   if((this.state.total - this.state.paid) === 0 && this.state.comments.toString().length < 10) {
    // Si el total es cero se requiere un comentario
    textareaClassName = 'border border-danger';
   } else if(this.state.sale && this.state.cash && (this.state.given - (this.state.total - this.state.paid) < 0)) {
    // Si se paga en efectivo, se comprueba si hay que dar cambio
    cashInputClassName = 'border border-danger';
    if(this.state.invoice) submitButtonDisabled = false;
    if(!this.state.validated) submitButtonTitle = 'Verificar';
   } else if(this.state.sale && this.state.paid > this.state.total) {
    // Si se dio más a cuenta del total, algo has hecho mal
    givenInputClassName = 'border border-danger';
   } else if(this.state.sale && this.state.cash && (this.state.given - (this.state.total - this.state.paid) > 0)) {
    submitButtonTitle = 'Verificar';
    submitButtonDisabled = false;
    if(this.state.validated) {
     cancelButtonShow = false;
     submitButtonTitle = 'He dado el cambio';
     cashBackAlert = 'bg-warning text-dark';
    }
   } else {
    submitButtonDisabled = false;
   }

   if(this.state.laddaloading) cancelButtonShow = false;
  }

  return (
   <Card>
    <CardHeader>
     <FastButtons reqAPI={this.props.reqAPI} addToCart={this.addToCart} />
    </CardHeader>

    <InputGroup className="product_search">
     { this.state.sale ?
     <InputGroupAddon addonType="prepend">
      <Button active color="success"><i className="fa fa-sign-in"></i>&nbsp; Entrada</Button>
      <Button outline color="danger" style={{"borderColor":"#a4b7c1"}} onClick={this.toogleSale}><i className="fa fa-sign-out"></i>&nbsp; Salida</Button>
     </InputGroupAddon>
     :
     <InputGroupAddon addonType="prepend">
      <Button outline color="success" style={{"borderColor":"#a4b7c1"}} onClick={this.toogleSale}><i className="fa fa-sign-in "></i>&nbsp; Entrada</Button>
      <Button active color="danger"><i className="fa fa-sign-out"></i>&nbsp; Salida</Button>
     </InputGroupAddon>
     }

     <ProductSearch reqAPI={this.props.reqAPI} handleInputEL={this.handleInputEL} handleCallback={this.addToCart} />
    </InputGroup>
    
    <CardBody>
     {this.state.items.length > 0 ?
     <Table className="shopping_cart">
      <thead>
       <tr>
        <th className={this.props.winSize >= 1300?"product":"product_small"}>Producto</th>
        <th className="price">Precio unidad <small>IVA incl.</small></th>
        <th className="quantity">Cantidad</th>
        <th id={'Tooltip-'+this.state.sale? "discount":"surcharge"} className={this.state.sale? "discount":"surcharge"}>
         { this.state.sale ? "Descuento" : "Recargo" }
         <Tooltip placement="top" isOpen={this.state.tooltip[this.state.sale? "discount":"surcharge"]} autohide={true} target={'Tooltip-'+this.state.sale? "discount":"surcharge"}>Ctrl + click para aplicar a todos</Tooltip>
        </th>
        {this.state.invoice?
        <th id="Tooltip-tax" className="tax">
         IVA
         <Tooltip placement="top" isOpen={this.state.tooltip.tax} autohide={true} target={'Tooltip-tax'}>Ctrl + click para aplicar a todos</Tooltip>
        </th>
        :null}
        <th className="total">Precio del lote</th>
       </tr>
      </thead>
      <tbody>
       {this.state.items.map((item, i) => (
       <tr key={i}>
        <td className={this.props.winSize >= 1300?"product":"product_small"}>
         <InputGroup>
          <div className="input-group-prepend">
           <span className="input-group-text">{item.name}</span>
          </div>
          <Input placeholder={item.notes ? item.notes : '...'} onChange={(e) => {this.setItemNotes(i, e)}} onKeyPress={this.handleKeyPress} onBlur={this.handleBlur} onFocus={this.handleFocus} size="3" />
         </InputGroup>
        </td>
        <td className="price">
         <Input placeholder={item.price.toFixed(2)} onChange={(e) => {this.setItemPrice(i, e)}} onKeyPress={this.handleKeyPress} onBlur={this.handleBlur} onFocus={this.handleFocus} size="7" />
        </td>
        <td className="quantity">
         <div style={{"display":"flex"}}>
          <div className="countButton" onClick={() => {this.delItemQuantity(i)}}>-</div>
          <Input placeholder={item.quantity} onChange={(e) => {this.setItemQuantity(i, e)}} onKeyPress={this.handleKeyPress} onBlur={this.handleBlur} onFocus={this.handleFocus} size="5" />
          <div className="countButton" onClick={() => {this.addItemQuantity(i)}}>+</div>
         </div>
        </td>
        <td className="discount">
         { this.state.sale
         ? <Input id="discount" name="tooltip" placeholder={item.discount ? item.discount : 0} onChange={(e) => {this.setItemDiscount(i, e)}} onClick={(e) => {this.handleDoubleClick(e)}} onKeyPress={this.handleKeyPress} onBlur={this.handleBlur} onFocus={this.handleFocus} size="3" />
         : <Input id="surcharge" name="tooltip" placeholder={item.surcharge ? item.surcharge : 0} onChange={(e) => {this.setItemSurcharge(i, e)}} onClick={(e) => {this.handleDoubleClick(e)}} onKeyPress={this.handleKeyPress} onBlur={this.handleBlur} onFocus={this.handleFocus} size="3" />
         }
        </td>
        {this.state.invoice?
        <td className="tax">
         <Input id="tax" name="tooltip" placeholder={item.tax ? item.tax : 0} onChange={(e) => {this.setItemTax(i, e)}} onClick={(e) => {this.handleDoubleClick(e)}} onKeyPress={this.handleKeyPress} onBlur={this.handleBlur} onFocus={this.handleFocus} size="3" />
        </td>
        :null}
        <td className="total">
         <Input placeholder={ item.finalprice ? item.finalprice.toFixed(2) : (0).toFixed(2) } disabled="disabled" />
        </td>
       </tr>
       ))}
      </tbody>
     </Table>
     :
     <Table></Table>
     }
    </CardBody>

    <CardFooter>
     <Row className="shopping_form">
      <Col xs={this.props.winSize >= 1300?"8":"6"}>
       {this.state.items.length > 0?
       <InputGroup className="input-prepend client_search">
        <ClientSearch reqAPI={this.props.reqAPI} handleCallback={this.setClient} />
        <ClientEditor reqAPI={this.props.reqAPI} open={this.state.modals.new_client} handleClose={() => {
         this.handleModal(['no_client','new_client'], false);
        }} onComplete={(client) => {
         this.handleModal(['no_client','new_client'], false);
         this.setClient(client);
        }} />
        <InputGroupAddon addonType="prepend">
         <Label className="switch switch-icon switch-secondary form-control-label billswitch">
          <Input type="checkbox" className="switch-input" checked={this.state.invoice} onChange={this.toogleInvoice} />
          <span className="switch-label billswitch_label" data-on="Factura" data-off="Factura?"></span>
          <span className="switch-handle billswitch_handle"></span>
         </Label>
        </InputGroupAddon>
       </InputGroup>
       :null}

       {this.state.client ?
       <Card>
        <CardHeader>
         <i className="icon-user"></i><strong>{this.state.client.name}</strong> {this.state.client.NID? '('+this.state.client.NID+')':''}
         <div className="card-actions">
          <Button onClick={this.unsetClient}><i className="fa fa-close"></i></Button>
         </div>
        </CardHeader>
        <CardBody>{this.state.client.address}<br />{this.state.client.postcode}, {this.state.client.locality}, {this.state.client.state}</CardBody>
       </Card>
       : null }

       <Input type="textarea" className={textareaClassName} placeholder={this.state.comments ? this.state.comments : 'Observaciones...'} onChange={(e) => {this.setComments(e)}} onKeyPress={this.handleKeyPress} onBlur={this.handleBlur} onFocus={this.handleFocus} />
      </Col>
      <Col xs={this.props.winSize >= 1300?"2":"3"}>
       <Card>
        <CardBody>
         <Table>
          <tbody>
           <tr>
            {this.state.paid > 0?
            <td className="text-center">
             <strong>Total</strong><br />
             <span className="biginput text-success strikethrough"><strong>{this.state.total.toFixed(2)}</strong> €</span><br />
             <span className="biginput text-success"><strong>{(this.state.total - this.state.paid).toFixed(2)}</strong> €</span>
            </td>
            :
            <td className="text-center">
             <strong>Total</strong><br /><span className="biginput text-success"><strong>{this.state.total.toFixed(2)}</strong> €</span>
            </td>
            }
           </tr>
          </tbody>
         </Table>
         {this.state.invoice?
         <Table>
          <tbody>
           <tr>
            <th>SubTotal:</th>
            <td>{this.state.subtotal.toFixed(2)}€</td>
           </tr>
           <tr>
            <th>Descuentos:</th>
            <td>{this.state.discounts.toFixed(2)}€</td>
           </tr>
           <tr>
            <th>IVA:</th>
            <td>{this.state.taxes.toFixed(2)}€</td>
           </tr>
          </tbody>
         </Table>
         : null }
        </CardBody>
        {this.state.sale?
        <FormGroup className={givenInputClassName}>
         <InputGroup>
          <div className="input-group-prepend">
           <span className="input-group-text">A cuenta</span>
          </div>
          <Input type="text" placeholder={this.state.paid.toFixed(2)} onChange={(e) => {this.setPaid(e)}} onKeyPress={this.handleKeyPress} onBlur={this.handleBlur} onFocus={this.handleFocus} />
          <div className="input-group-append">
           <span className="input-group-text"><i className="fa fa-eur"></i></span>
          </div>
         </InputGroup>
        </FormGroup>
        :null}
        <CardFooter>
         <Table>
          <tbody>
           <tr>
            <td colSpan="2" style={{"textAlign":"center"}}>
             <Label className="switch switch-icon switch switch-secondary-outline paytype_icon">
              <Input type="checkbox" className="switch-input" checked={this.state.cash} onChange={this.handlePayMethod} />
              <span className="switch-label paytype_label" data-on="Efectivo" data-off="Banco"></span>
              <span className="switch-handle paytype_handle"></span>
             </Label>
            </td>
           </tr>
          </tbody>
         </Table>
        </CardFooter>
       </Card>
      </Col>
      <Col xs={this.props.winSize >= 1300?"2":"3"}>
       <Card>
        <CardBody className={cashBackAlert}>
         {this.state.sale?
         this.state.cash ?
         <Table>
          <tbody>
           <tr>
            <td className="text-center">
             <strong>Cambio</strong><br /><span className="biginput text-danger"><strong>{this.getCash().toFixed(2)}</strong> €</span>
            </td>
           </tr>
          </tbody>
         </Table>
         :
         <Table>
          <tbody>
           <tr>
            <td className="text-center">
             <strong>A cobrar</strong><br /><span className="biginput text-danger"><strong>{(this.state.total - this.state.paid).toFixed(2)}</strong> €</span>
            </td>
           </tr>
          </tbody>
         </Table>:
         <Table>
          <tbody>
           <tr>
            <td className="text-center">
             <strong>A pagar</strong><br /><span className="biginput text-danger"><strong>{this.getCash().toFixed(2)}</strong> €</span>
            </td>
           </tr>
          </tbody>
         </Table>
         }
        </CardBody>

        {this.state.cash && this.state.sale ?
        <FormGroup className={cashInputClassName}>
         <InputGroup>
          <div className="input-group-prepend">
           <span className="input-group-text">Entregado</span>
          </div>
          <Input type="text" placeholder={this.state.given.toFixed(2)} onChange={(e) => {this.setGiven(e)}} onKeyPress={this.handleKeyPress} onBlur={this.handleBlur} onFocus={this.handleFocus} />
          <div className="input-group-append">
           <span className="input-group-text"><i className="fa fa-eur"></i></span>
          </div>
         </InputGroup>
        </FormGroup>
        : null }
        
        <CardFooter>
         <Table>
          <tfoot>
           <tr>
            <td colSpan="2" style={{"textAlign":"center"}}>
             {cancelButtonShow?<Button color="secondary" disabled={cancelButtonDisabled} onClick={() => {this.handleModal('do_reset', true)}} className={cancelButtonClassName}>{cancelButtonTitle}</Button>:null}
             <LaddaButton type="submit" disabled={submitButtonDisabled} onClick={this.handleSubmit} data-style={EXPAND_LEFT} loading={this.state.laddaloading} className={submitButtonClassName}>{submitButtonTitle}</LaddaButton>
            </td>
           </tr>
          </tfoot> 
         </Table>
        </CardFooter>
       </Card>
      </Col>
     </Row>
    </CardFooter>

    <Modal isOpen={this.state.modals.no_taxes}>
     <ModalBody>
      <h2>Atención!</h2>
      <p>Existen productos en la lista sin IVA aplicado.<br />Es necesario aplicar un impuesto a dichos productos.</p>
     </ModalBody>
     <ModalFooter>
      <Button color="success" onClick={this.applyTaxes}>Aplicar automáticamente el 21% de IVA</Button>{' '}
      <Button color="danger" onClick={this.skipTaxes}>Lo revisaré manualmente</Button>
     </ModalFooter>
    </Modal>

    <Modal isOpen={this.state.modals.no_client}>
     <ModalBody>
      <h2>Atención!</h2>
      <p>No se puede crear una factura sin asociarla un cliente.<br />Usa el buscador para asignar un cliente o crealo ahora.</p>
     </ModalBody>
     <ModalFooter>
      <Button color="primary" onClick={() => { this.handleModal('new_client', true) }}>Crear nuevo cliente</Button>
      <Button color="success" onClick={() => { this.handleModal('no_client', false) }}>Entendido</Button>
     </ModalFooter>
    </Modal>

    <Modal isOpen={this.state.modals.no_comment}>
     <ModalBody>
      <h2>Atención!</h2>
      <p>Si el total es cero, debe de escribir un comentario explicando el motivo.</p>
     </ModalBody>
     <ModalFooter>
      <Button color="success" onClick={() => { this.handleModal('no_comment', false) }}>Entendido</Button>
     </ModalFooter>
    </Modal>

    <Modal isOpen={this.state.modals.do_reset}>
     <ModalBody>
      <h2>Atención!</h2>
      <p>Se va a borrar todo y se perderan todos los cambios.</p>
     </ModalBody>
     <ModalFooter>
      <Button color="success" onClick={() => { this.handleModal('do_reset', false) }}>Cancelar</Button>
      <Button color="danger" onClick={() => { this.resetAll() }}>Volver a empezar</Button>
     </ModalFooter>
    </Modal>

   </Card>
  )
 }
}

const mapSizesToProps = ({ width }) => ({ winSize: width })
export default withSizes(mapSizesToProps)(ShoppingCart)



// WEBPACK FOOTER //
// ./src/views/ShoppingCart/ShoppingCart.js